import Installation from './views/Installation';
import State from './views/State';
import Getters from './views/Getters';
import Mutations from './views/Mutations';
import Actions from './views/Actions';

export const MENU_ITEMS = [
  {
    label: 'Installation',
    component: Installation
  },
  {
    label: 'Config',
    component: State,
    children: ['modules', 'withStore']
  },
  {
    label: 'Getters',
    component: Getters,
    children: [
      'useGetter', 'useGetter with modules'
    ]
  },
  {
    label: 'Mutations',
    component: Mutations,
    children: [
      'useMutation', 'useMutations', 'useMutation with modules'
    ]
  },
  {
    label: 'Actions',
    component: Actions,
    children: [
      'useAction',
      'useActions',
      'useActionOnMount',
      'useAction with modules'
    ]
  }
]